<p class="total">  {{ 'pages.estimate.total.info' | translate}} : {{total}} </p>
<p class="total-info">{{'pages.estimate.total.subtitle' | translate}}</p>
